import { useContext } from 'react';
import { PanelTitleContext } from './panelTitleCtx';

export function usePanelTitle() {
  const ctx = useContext(PanelTitleContext);
  if (!ctx) throw new Error('usePanelTitle must be used within PanelTitleProvider');
  return ctx;
}
